import { render, staticRenderFns } from "./BlackHoleUpgradeRow.vue?vue&type=template&id=eb5ab370&scoped=true&"
import script from "./BlackHoleUpgradeRow.vue?vue&type=script&lang=js&"
export * from "./BlackHoleUpgradeRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5ab370",
  null
  
)

export default component.exports